import React from 'react';
import { useFormContext } from 'react-hook-form';
import RoutineSelector from './RoutineSelector';
import ArgumentsForm from './ArgumentsForm';
import { Alert } from 'antd';

export default function GenerateCampaignModalContent() {
  const form = useFormContext();
  const routineName = form.watch('routineName');
  return (
    <div className="w-full space-y-4">
      <Alert
        message="Make sure to fill in all the fields to generate the campaign"
        showIcon
        type="info"
      />
      <RoutineSelector />
      {routineName && <ArgumentsForm />}
    </div>
  );
}
